import React from 'react';
import classNames from 'classnames';
import PropTypes from '../../constants/prop-types';
import './Icon.scss';

const Icon = ({ icon, className, tag: Tag, ...rest }) => (
  <Tag {...rest} className={classNames([`icon-${icon}`], className)} />
);

Icon.propTypes = {
  icon: PropTypes.string.isRequired,
  className: PropTypes.string,
  tag: PropTypes.tag,
};

Icon.defaultProps = {
  className: null,
  tag: 'span',
};

export default Icon;
